import { Compass, RefreshCcw } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

export const Team = () => (
    <section id="echipa" data-testid="team-section" className="py-16 sm:py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
            <div className="lg:col-span-6">
                <SectionHeading
                    testid="team-heading"
                    eyebrow="Echipa"
                    title="Doi oameni, nu un call-center"
                    text="Suntem doi oameni implicați personal. Unul conduce fiecare relație de la început până la capăt; celălalt cunoaște cazul și disponibilitatea — ca tu să nu repeți niciodată povestea."
                />
                <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <Reveal delay={0.05}>
                        <div className="h-full rounded-3xl bg-creamlight p-6 ring-1 ring-teal/10" data-testid="team-role-primary">
                            <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-teal/10 text-teal">
                                <Compass className="h-5 w-5" />
                            </span>
                            <h3 className="mt-4 font-serif text-xl font-semibold text-charcoal">Responsabilul tău</h3>
                            <p className="mt-2 text-sm text-charcoal/70 leading-relaxed">
                                Conduce relația cu familia ta: ține planul, confirmările și calendarul.
                            </p>
                        </div>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <div className="h-full rounded-3xl bg-creamlight p-6 ring-1 ring-teal/10" data-testid="team-role-backup">
                            <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-coral/10 text-coral">
                                <RefreshCcw className="h-5 w-5" />
                            </span>
                            <h3 className="mt-4 font-serif text-xl font-semibold text-charcoal">Cel de-al doilea om</h3>
                            <p className="mt-2 text-sm text-charcoal/70 leading-relaxed">
                                Cunoaște cazul și sare în ajutor fără pauze de comunicare. Continuitate reală.
                            </p>
                        </div>
                    </Reveal>
                </div>
                <Reveal delay={0.18}>
                    <p className="mt-8 border-l-2 border-coral pl-5 font-serif text-xl sm:text-2xl italic text-teal/90 leading-snug" data-testid="team-quote">
                        „Numele nostru are două sensuri: ține-te de noi — sprijin; ține de noi — ne ținem de sarcinile convenite.”
                    </p>
                </Reveal>
            </div>
            <Reveal className="lg:col-span-6" delay={0.1}>
                <div className="relative">
                    <div className="absolute -bottom-5 -right-5 h-32 w-32 rounded-full bg-teal/10" />
                    <div className="relative overflow-hidden rounded-[2.5rem] ring-1 ring-teal/10 shadow-2xl shadow-teal/10" data-testid="team-image">
                        <img
                            src="https://images.unsplash.com/photo-1702648156180-25d8be9c9527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHxfZWxkZXJseSUyMGhvbWUlMjBjYXJlJTIwd2FybSUyMG5hdHVyYWwlMjBsaWdodCUyMGhlbHBlciUyMGNvbnZlcnNhdGlvbnxlbnwwfHx8fDE3OTI1MDQwOTN8MA&ixlib=rb-4.1.0&q=85"
                            alt="O conversație caldă acasă, între echipă și familie"
                            className="h-[24rem] sm:h-[30rem] w-full object-cover"
                        />
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
